export default __webpack_public_path__ + "static/media/perfect10dance.d7689f3c.png";